const NaCountryCodeApiUrls = {
  ROOT:   `${process.env.REACT_APP_CODE_MAINTENANCE_ORIGIN_URL}/code-maintenance/nacountrycode`,
  GET:    `${process.env.REACT_APP_CODE_MAINTENANCE_ORIGIN_URL}/code-maintenance/nacountrycode/get`,
  POST:   `${process.env.REACT_APP_CODE_MAINTENANCE_ORIGIN_URL}/code-maintenance/nacountrycode/create`,
  PUT:    `${process.env.REACT_APP_CODE_MAINTENANCE_ORIGIN_URL}/code-maintenance/nacountrycode/update`,
  DELETE: `${process.env.REACT_APP_CODE_MAINTENANCE_ORIGIN_URL}/code-maintenance/nacountrycode/delete`,
}

export default NaCountryCodeApiUrls
